<template>
    <!-- exhibition-product .ep -->
    <div class="ecb">
        <div class="header-tool">
            <div class="header-tool-info">
                <Breadcrumb>
                <!-- 展商编辑产品页面 -->
                    <BreadcrumbItem>我的云店</BreadcrumbItem>
                    <BreadcrumbItem to="/exhibition/index/product/allpro">上传产品</BreadcrumbItem>
                    <BreadcrumbItem>编辑产品</BreadcrumbItem>
                </Breadcrumb>
                <div class="header-tool-title">{{ exhibition.name }}</div>
            </div>
            <div class="f-tar" style="padding-top: 37px">
                <Button @click="$router.push('/exhibition/index/product/allpro')">返回</Button>
            </div>
        </div>
        <div class="editpro">
            <div class="editpro-box">
                <Form ref="form" :model="form" :label-width="120" :rules="ruleValidate">
                    <FormItem label="产品展示组:">
                        <Select v-model="form.GroupInfo" multiple style="width: 400px">
                            <template v-if="list && list.items && list.items.length">
                                <Option v-for="item in list.items" :value="item.id" :key="item.id">{{ item.name }}</Option>
                            </template>
                        </Select>
                    </FormItem>
                    <FormItem label="招商区域:" prop="zhaoShangRegion" :required="true">
                        <Row v-for="(item, index) in form.zhaoShangRegion" :key="'cityInfo-' + index"
                            style="width: 400px; margin-bottom: 5px">
                            <Col span="22">
                            <Cascader v-model="form.zhaoShangRegion[index]" filterable placeholder="输入关键词进行地区搜索"
                                :data="countryList" :load-data="changeZhaoShangRegion" :key="'zhaoShangRegionArr-' + index">
                            </Cascader>
                            </Col>
                            <Col span="2" class="ie-icon" style="text-align: center">
                            <Icon type="ios-add-circle-outline" v-if="index === 0" @click="addCityArr()"
                                style="color: #2d8cf0; font-size: 20px; cursor: pointer" />
                            <Icon type="ios-remove-circle-outline" v-else
                                style="color: red; font-size: 20px; cursor: pointer" @click="delCityArr(index)" />
                            </Col>
                        </Row>
                        <p class="pro-tip">为增加您产品的宣传效果，请添加招商区域</p>
                    </FormItem>
                    <FormItem label="产品类别:" prop="category" :required="true">
                        <Cascader v-model="form.category" :data="type" filterable style="width: 400px"
                            @on-change="changeCategory($event); validSingle('form', 'category');" placeholder="输入关键词进行类别搜索">
                        </Cascader>
                        <p class="pro-tip">为增加您产品的宣传效果，请添加产品类别</p>
                    </FormItem>

                    <FormItem label="产品标签:" prop="tag" :required="true">
                        <Row v-for="(item, index) in form.Protag" :key="'proInfo-' + index"
                            style="width: 400px; margin-bottom: 5px">
                            <Col span="23">
                            <Cascader v-model="form.Protag[index]" :value="form.Protag[index]" :data="ProTagList" filterable
                                :key="'Protag-' + index"  @on-change="changeProtag" placeholder="输入关键词进行类别搜索"></Cascader>
                            </Col>
                            <Col span="1" class="ie-icon" style="text-align: center">
                            <Icon type="ios-add-circle-outline" v-if="index === 0" @click="addProductTag()"
                                style="color: #2d8cf0; font-size: 20px; cursor: pointer" />
                            <Icon type="ios-remove-circle-outline" v-else
                                style="color: red; font-size: 20px; cursor: pointer" @click="delProductTag(index)" />
                            </Col>
                        </Row>
                        <p class="pro-tip">为增加您产品的宣传效果，请添加产品标签</p>
                        <p class="pro-tip tipText" v-if="showTextXZ">新品荟需为2021年后的产品，选择后的产品将进入主办后台进行审核</p>
                        <!-- <p class="pro-tip tipText" >新品荟需为2021年后的产品，选择后的产品将进入主办后台进行审核</p> -->
                    </FormItem>

                    <FormItem label="产品适用渠道:" prop="proChannel" :required="true">
                        <Select v-model="form.proChannel" multiple style="width: 400px">
                            <Option v-for="(item, index) in proChannels" :value="item.name" :key="index">{{ item.name }}
                            </Option>
                        </Select>
                    </FormItem>
                    <FormItem label="产品应用科室:" prop="proOffice" :required="true">
                        <Select v-model="form.proOffice" multiple style="width: 400px">
                            <Option v-for="(item, index) in proOffices" :value="item.name" :key="index">{{ item.name }}
                            </Option>
                        </Select>
                    </FormItem>
                    <FormItem label="产品认证:" :required="true">
                        <authSelect v-model="form.Authentication" ref="authSelect" @auth="setAuthTxt"></authSelect>
                        <div class="ivu-form-item-error-tip" v-if="validOpen && authSelectValid">
                            {{ authSelectValid }}
                        </div>
                        <p class="pro-tip">为增加您产品的宣传效果，请添加产品认证</p>
                    </FormItem>
                    <FormItem label="质量体系认证:">
                        <authSelect v-model="form.CertificateQualities" :type="2" ref="qualitiesSelect" @auth="setAuthTxt2">
                        </authSelect>
                        <div class="ivu-form-item-error-tip" v-if="validOpen2 && qualitiesSelectValid">
                            {{ qualitiesSelectValid }}
                        </div>
                    </FormItem>
                    <FormItem label="展区:" prop="exArea" :required="true">
                        <Select v-model="form.exArea" style="width:400px">
                            <Option v-for="item in exList" :value="item.exArea" :key="item.exArea">{{ item.exArea }}</Option>
                        </Select>
                    </FormItem>
                    <FormItem label="产品名称:" prop="name">
                        <Input v-model="form.name" placeholder="请输入产品名称" style="width: 400px"></Input>
                    </FormItem>
                    <FormItem label="产品英文名称:" prop="NameEn">
                        <Input v-model="form.NameEn" placeholder="请输入产品名称" style="width: 400px"></Input>
                    </FormItem>
                    <FormItem label="产品宣传亮点:" prop="productFeature" :required="true">
                        <Input type="textarea" style="width:400px;" v-model="form.productFeature" :rows="6"
                            placeholder="请输入产品宣传亮点"></Input>
                    </FormItem>
                    <FormItem label="产品图:" prop="proImg">
                        <div>
                            <upload ref="upload1" :fileList="uploadBanner" :config="uploadBannerConfig"
                                @upload-ok="bannerOK" />
                        </div>
                    </FormItem>
                    <FormItem label="主图视频:" prop="proVideo">
                        <div>
                            <upload :config="uploadVideoConfig" @upload-ok="videoOK" :fileList="uploadVideo"
                                class="upload-1" ref="upload2" />
                        </div>
                    </FormItem>
                    <!-- <FormItem>
            <Checkbox size="large" v-model="form.apply" @on-change="changeApply()">
              <span style="display: inline-block;width: 10px;"></span>开启体验
            </Checkbox>
          </FormItem>-->
                    <FormItem label="体验名额:" v-show="form.apply">
                        <InputNumber v-model="form.applyMaxCount" :min="0" style="width: 100px; margin-right: 10px">
                        </InputNumber>人
                        <span style="font-size: 12px; margin-left: 10px">(0表示不限量)</span>
                    </FormItem>
                    <FormItem label="报名时间:" prop="date" v-show="form.apply">
                        <DatePicker type="datetimerange" format="yyyy-MM-dd HH:mm" placeholder="请选择报名时间"
                            style="width: 300px" v-model="applyDate"></DatePicker>
                    </FormItem>
                    <!-- <FormItem>
            <Checkbox size="large" v-model="form.showPrice" @on-change="changePrice()">
              <span style="display: inline-block;width: 10px;"></span>显示价格
            </Checkbox>
          </FormItem>
          <FormItem label="价格:" v-show="form.showPrice" style="display:inline-block">
            <InputNumber
              v-model="form.price"
              placeholder="0"
              :min="0"
              style="width:100px;margin-right:10px;"
            ></InputNumber>元
          </FormItem>
          <FormItem label="划线价格:" v-show="form.showPrice" style="display:inline-block">
            <InputNumber
              v-model="form.linePrice"
              placeholder="0"
              :min="0"
              style="width:100px;margin-right:10px;"
            ></InputNumber>元
          </FormItem> -->
                    <FormItem>
                        <Checkbox size="large" v-model="form.isShow">
                            <span style="display: inline-block; width: 10px"></span>开启显示
                        </Checkbox>
                    </FormItem>
                    <FormItem label="显示顺序:">
                        <InputNumber v-model="form.showIndex" :min="0" style="width: 100px; margin-right: 10px">
                        </InputNumber>
                        <p style="font-size: 12px">
                            (数字越小在您的产品显示列表中显示越靠前)
                        </p>
                    </FormItem>

                    <FormItem label="产品简介:">
                        <Input type="textarea" style="width: 400px" v-model="form.intro" :rows="6"
                            placeholder="请输入产品简介"></Input>
                    </FormItem>
                    <FormItem label="产品英文简介:" prop="IntroductionEn">
                        <Input type="textarea" style="width: 400px" v-model="form.IntroductionEn" :rows="6"
                            placeholder="请输入产品英文简介"></Input>
                    </FormItem>

                    <!-- <FormItem label="招商区域:" prop="zhaoShangRegion" :required="true">
            <Cascader
              v-model="form.zhaoShangRegion"
              :data="provinces"
              filterable
              style="width: 400px;"
              @on-change="validSingle('form', 'zhaoShangRegion')"
            ></Cascader>
          </FormItem>-->

                    <FormItem label="产品详情:" class="ivu-form-item-required">
                        <div class="no-padding">
                            <customComponentCommon v-model="Introduction" :type="commonType" @change="changModal">
                            </customComponentCommon>
                        </div>
                    </FormItem>
                </Form>
                <div style="width: 100%; padding-left: 120px">
                    <Button type="primary" @click="handleSubmit('form', 0)"
                        style="width: 140px; height: 35px; font-size: 14px" :loading="initLoading">保存</Button>
                    <Button type="primary" @click="handleSubmit('form', 1)"
                        style="width: 140px;height: 35px;font-size: 14px;margin-left: 20px;"
                        :loading="initLoading">保存并预览</Button>
                </div>
            </div>
        </div>

        <Contact />
    </div>
</template>


<script>
import { provinces } from '@/other/provinces'
import Contact from '@components/Contact/Contact'
import upload from '@components/upLoad/upLoad'
import { mapGetters, mapActions } from 'vuex'
import customComponentCommon from '@components/custom-component/custom-component-common.vue'
import authSelect from '@components/auth-select/auth-select.vue'

export default {
    name: 'exhibition-product-edit',
    data () {
        const validateProImg = (rule, value, callback) => {
            if (this.uploadBanner && this.uploadBanner.length) {
                callback()
            } else {
                callback(new Error('请上传产品图片'))
            }
        }
        const proApply = (rule, value, callback) => {
            if (this.form.apply) {
                if (this.applyDate[1]) {
                    callback()
                } else {
                    callback(new Error('请选择体验报名时间'))
                }
            } else {
                callback()
            }
        }
        const zhaoShangRegionValid = (rule, value, callback) => {
            if (value && value[0] && value[0].length) {
                callback()
            } else {
                callback(new Error('请选择招商区域'))
            }
        }
        const categoryValid = (rule, value, callback) => {
            if (value && value.length) {
                callback()
            } else {
                callback(new Error('请选择产品类别'))
            }
        }
        const tagValid = (rule, value, callback) => {
            if (JSON.stringify(this.TagData)) {
                callback()
            } else {
                callback(new Error('请选择产品标签'))
            }
        }
        const channelValid = (rule, value, callback) => {
            if (value && value.length) {
                callback()
            } else {
                callback(new Error('请选择产品适用渠道'))
            }
        }
        const officeValid = (rule, value, callback) => {
            if (value && value.length) {
                callback()
            } else {
                callback(new Error('请选择产品应用科室'))
            }
        }
        return {
            showTextXZ: false,
            commonType: 2, //
            list: null,
            pageSize: 16,
            pageIndex: 1,
            totalCount: 0,
            countryList: [],

            editData: '',
            Introduction: [], // 产品详情

            uploadBanner: [], // 产品图
            uploadVideo: [], // 主图视频
            applyDate: [], // 体验报名时间
            config: {
                fileType: 'img',
                headers: {},
                action: '',
                format: ['jpg', 'jpeg', 'png'],
                'max-size': 2048,
                remind:
                    '(图片要求：2M以下的jpg或png，建议尺寸为900*600px，拖拽上传图片，最多上传15张)',
                limitNum: 15,
            },
            form: {
                name: '', // 产品名称
                NameEn: '',
                apply: false, // 是否开启体验
                applyMaxCount: 0, // 体验名额
                showPrice: true, // 是否显示价格
                showIndex: 0, // 显示顺序
                price: 0, // 价格
                linePrice: 0, // 划线价格
                isShow: true, // 是否显示
                GroupInfo: '', // 分组信息
                category: [], // 展品分类
                tag: [], // 展品标签
                Protag: [[]],
                zhaoShangRegion: [[]],
                Authentication: [],
                proChannel: [], // 产品适用渠道
                proOffice: [], // 产品应用科室
                CertificateQualities: [], // 质量体系认证
                intro: '',
                IntroductionEn: '',
                productFeature: '', // 产品宣传亮点
                exArea: '', // 展区
            },
            authSelectValid: '', // 产品认证的信息
            qualitiesSelectValid: '', // 质量体系认证的信息
            ruleValidate: {
                name: [
                    { required: true, message: '产品名称不能为空', trigger: 'blur' },
                ],
                NameEn: [
                    { required: true, message: '产品英文名称不能为空', trigger: 'blur' },
                ],
                IntroductionEn: [
                    { required: true, message: '产品英文简介不能为空', trigger: 'blur' },
                ],
                productFeature: [
                    { required: true, message: '产品宣传亮点不能为空', trigger: 'blur' },
                ],
                exArea: [
                    { required: true, message: '展区不能为空', trigger: 'change' },
                ],
                zhaoShangRegion: [
                    {
                        validator: zhaoShangRegionValid,
                        trigger: 'change',
                    },
                ],
                category: [
                    {
                        validator: categoryValid,
                        trigger: 'change',
                    },
                ],
                tag: [
                    {
                        validator: tagValid,
                        trigger: 'change',
                    },
                ],
                proImg: [
                    { required: true, validator: validateProImg, trigger: 'change' },
                ],
                date: [{ required: true, validator: proApply, trigger: 'change' }],
                proChannel: [
                    {
                        validator: channelValid,
                        trigger: 'change',
                    },
                    {
                        validator: channelValid,
                        trigger: 'blur',
                    },
                ],
                proOffice: [
                    {
                        validator: officeValid,
                        trigger: 'change',
                    },
                    {
                        validator: officeValid,
                        trigger: 'blur',
                    },
                ],
            },
            videoList: [], // 视频详情

            provinces: provinces.data,
            ProTagList: [], // 产品标签
            ProAuthList: [], // 产品认证
            type: [],
            type2: [],
            validOpen: false,
            validOpen2: false,

            CategoryData: null,
            TagData: null,
            proChannels: [], // 产品适用渠道列表
            proOffices: [], // 产品应用科室列表
            initLoading: false, // 初始化类目请求
            arr: [],
            inDate: "",
            allProTypeList: [],
            CategoryName: '',
            exList: [],
        }
    },
    computed: {
        uploadBannerConfig () {
            let config = JSON.parse(JSON.stringify(this.config))
            config.id = 'upload_1'
            config.headers = this.formHeaders
            config.action = this.uploadUrl
            return config
        },
        uploadVideoConfig () {
            let config = JSON.parse(JSON.stringify(this.config))
            config.id = 'upload_2'
            config.fileType = 'video'
            config.headers = this.formHeaders
            config.action = this.uploadVideoUrl
            config.format = ['mp4']
            config['max-size'] = 51200 // 50M
            config.limitNum = 1
            config.remind =
                '(视频要求：视频大小不超过50M，建议视频时长9-30秒，视频宽高比16:9)'
            return config
        },
        ...mapGetters({
            uploadUrl: 'getUploadUrl',
            uploadVideoUrl: 'getUploadVideoUrl',
            formHeaders: 'getFormHeaders',
            company: 'loginModule/getCompany',
            exhibition: 'loginModule/getExhibition',
        }),
        query () {
            return this.$router.history.current.query
        },
        option () {
            return { compId: this.company.id, pageSize: 1000 }
        },
        statusPar () {
            return JSON.parse(this.$route.query.info)
        },
    },
    async created () {
       
        this.init()

        let res = await this.getProductByGroupId({
        groupId: this.exhibition.groupId,
        level: -1,
        loadChild: true,
      }) // 暂时先写死了值
      if (res && res.length) {
        this.allProTypeList = res
      } 
      console.log(this.allProTypeList,'allProTypeList');

    },
    destroyed () {
        this.$Message.destroy()
    },
    methods: {
        ...mapActions({
            getProductGroup: 'productModule/getProductGroup',
            getProductById: 'productModule/getProductById',
            editProduct: 'productModule/editProduct',

            getRegionList: 'exhibitionModule/getRegionList',
            getProChannels: 'exhibitionModule/getProChannels',
            getProOffices: 'exhibitionModule/getProOffices',
            getCountryList: 'exhibitionModule/getCountryList',
            getCityByParentId: 'exhibitionModule/getCityByParentId',

            postProductTagAuditLog: 'exhibitionModule/postProductTagAuditLog',


            transformCustomData: 'customComponentModule/transformCustomData',
            transformReqCustomData: 'customComponentModule/transformReqCustomData',

            getProductByGroupId: 'categoryModule/getProductByGroupId', // 根据展会Id获取产品类别

            getProTag: 'companyInfoModule/getProTag', // 获取产品标签
            getProAuth: 'companyInfoModule/getProAuth', // 获取产品认证
            getByRemoveAuditByExId: 'exhibitionModule/getByRemoveAuditByExId',
            getExAreaList: 'productModule/getExAreaList',
        }),
        setAuthTxt (txt) {
            this.authSelectValid = txt
            if (txt) this.validOpen = true
        },
        setAuthTxt2 (txt) {
            this.qualitiesSelectValid = txt
            if (txt) this.validOpen2 = true
        },
        async getEx () {
            let list = await this.getExAreaList({
                compid: this.company.id,
                ExhibitionId: this.exhibition.id
            })
            if (Array.isArray(list) && list.length) {
                this.exList = list
            } else if (list && list.items && list.items.length) {
                this.exList = list.items
            }
        },
        setDefaultExhibition () {
            if (this.exList.length && !this.form.exArea) {
                this.form.exArea = this.exList[0].exArea
            }
        },
        async init () {
            this.initLoading = true
            const msg = this.$Message.loading({
                content: 'Loading...',
                duration: 0,
            })
            let listData = await this.getProductGroup(this.option)

            if (listData && listData.items) {
                listData.items.forEach((c) => {
                    c.introduction = JSON.parse(c.introduction)
                })
                this.list = listData
                this.pageSize = this.list.pageSize
                this.pageIndex = this.list.pageIndex
                this.totalCount = this.list.totalCount
            }

            if (!this.query.id) return
            this.editData = await this.getProductById(this.query.id)
            console.log('editData', this.editData)

            this.form.name = this.editData.name
            this.form.NameEn = this.editData.nameEn
            this.form.IntroductionEn = this.editData.introductionEn
            this.form.exArea = this.editData.exArea
            this.form.productFeature = this.editData.productFeature
            await this.getEx()
            this.setDefaultExhibition()
            if (JSON.parse(this.editData.banner)) {
                this.uploadBanner = JSON.parse(this.editData.banner)
            }
            if (JSON.parse(this.editData.video).Link) {
                this.uploadVideo = [
                    {
                        url: JSON.parse(this.editData.video).Link,
                        src: JSON.parse(this.editData.video).Img,
                    },
                ]
            }
            if (this.editData.applicableChannels) {
                this.editData.applicableChannels = JSON.parse(
                    this.editData.applicableChannels
                )
                this.form.proChannel = this.editData.applicableChannels
            }
            if (this.editData.appliedSectionOffices) {
                this.editData.appliedSectionOffices = JSON.parse(
                    this.editData.appliedSectionOffices
                )
                this.form.proOffice = this.editData.appliedSectionOffices
            }
            this.form.apply = this.editData.isApply
            this.form.applyMaxCount = this.editData.applyMaxCount
            if (this.editData.applyStart && this.editData.applyEnd) {
                this.applyDate = [this.editData.applyStart, this.editData.applyEnd]
            }
            // if (this.editData.price !== 0 || this.editData.linePrice !== 0) {
            //   this.form.showPrice = true;
            //   this.form.price = this.editData.price;
            //   this.form.linePrice = this.editData.linePrice;
            // } else {
            //   this.form.showPrice = false;
            // }
            this.form.isShow = this.editData.isShow
            this.form.showIndex = this.editData.showIndex
            this.form.intro = this.editData.intro
            this.inDate = this.editData.inDate.slice(0, 4)
            if (
                this.editData.category &&
                this.editData.category.indexOf('{') !== -1
            ) {
                const category = JSON.parse(this.editData.category)
                const categoryArr = []
                if (category.Value) {
                    categoryArr.push(category.Value)
                    if (category.List) {
                        if (category.List[0]) {
                            categoryArr.push(category.List[0].Value)
                            if (category.List[0].List) {
                                categoryArr.push(category.List[0].List[0].Value)
                            }
                        }
                    }
                }
                this.form.category = categoryArr
            }
            // if (this.editData.tag && this.editData.tag.indexOf("[") !== -1) {
            //   const tag = JSON.parse(this.editData.tag);
            //   const tagArr = [];
            //   if (tag.Id) {
            //     tagArr.push(tag.Id);
            //     if (tag.List) {
            //       if (tag.List[0]) {
            //         tagArr.push(tag.List[0].Id);
            //         if (tag.List[0].List) {
            //           tagArr.push(tag.List[0].List[0].Id);
            //         }
            //       }
            //     }
            //   }
            //   this.form.tag = tagArr;
            // }
            if (this.editData.tag) {
                //console.log(this.editData.tag,' this.form.Protag');
                let ProTagData = await this.getProTag()
                if (ProTagData && ProTagData.length) {
                    ProTagData.map((c) => {
                        c.value = c.id
                        c.label = c.name
                        c.children = JSON.parse(JSON.stringify(c.list))
                        c.children.map((v) => {
                            v.value = v.id
                            v.label = v.name
                            v.children = JSON.parse(JSON.stringify(v.list))
                            v.children.map((z) => {
                                z.value = z.id
                                z.label = z.name
                                z.children = JSON.parse(JSON.stringify(z.list))
                            })
                        })
                    })
                    this.ProTagList = ProTagData
                    // console.log('产品标签' + JSON.stringify(this.ProTagList))
                } else {
                    this.ProTagList = []
                }
                let arr = []

                console.log(JSON.parse(this.editData.tag))
                let newArray = []
                this.ProTagList.map((item) => {
                    JSON.parse(this.editData.tag).map((item1) => {
                        if (item1 != null) {
                            if (item.id == item1.Id) {
                                newArray.push(item1)
                            }
                        }
                    })
                })
                arr = newArray
                // arr.splice(2,1)
                console.log(arr)
                const tagArr = []
                arr.forEach((e) => {
                    tagArr.push([])
                })

                this.form.Protag.push(JSON.parse(this.editData.tag))
                for (let i = 0; i < arr.length; i++) {
                    if (arr[i].Id) {

                        if (arr[i].Id == 'fcb459d0-9565-413b-832d-f25bba4c3567' || arr[i].Id == '45866a37-7712-4177-8f77-0183d1357578' || arr[i].Id == 'e2f055e2-4cec-4875-84c2-2624526391ae' ) {
                            this.showTextXZ = true
                        }

                        console.log(tagArr[i], 'id')
                        tagArr[i].push(arr[i].Id)
                        if (arr[i].List) {
                            if (arr[i].List[0]) {
                                tagArr[i].push(arr[i].List[0].Id)
                                if (arr[i].List[0].List) {
                                    tagArr[i].push(arr[i].List[0].List[0].Id)
                                }
                            }
                        }
                    }
                }

                // if (this.form.Protag.length > 0) { 
                this.form.Protag = tagArr
                // } else {
                //   deubgger
                //   this.form.Protag.push('884018a4-c20f-48fd-8458-82cc8170f058')
                // }
                if (this.form.Protag.length == 0 && this.statusPar.length == 0) {
                    this.form.Protag = [[]]
                }

                // 回显新品和臻品两个标签
                console.log(this.statusPar,'statusPar');
                this.statusPar.map((itemInfo) => {
                    if(itemInfo.auditStatus == 'pass'){
                        this.form.Protag.push([itemInfo.tagId])
                    }
                })

                console.log(this.form.Protag, 'this.form.Protag')
            }
            if (
                this.editData.authentication &&
                this.editData.authentication.indexOf('[') !== -1
            ) {
                this.form.Authentication = JSON.parse(this.editData.authentication)
                this.form.Authentication.forEach((c) => {
                    if (c.Name == '其他') {
                        c.FilePath = 'other'
                    }
                })
            }
            if (
                this.editData.certificateQualities &&
                this.editData.certificateQualities.indexOf('[') !== -1
            ) {
                this.form.CertificateQualities = JSON.parse(
                    this.editData.certificateQualities
                )
                this.form.CertificateQualities.forEach((c) => {
                    if (c.Name == '其他') {
                        c.FilePath = 'other'
                    }
                })
            }
            if (
                this.editData.introduction &&
                this.editData.introduction.indexOf('[') !== -1
            ) {
                this.Introduction = await this.transformCustomData(
                    JSON.parse(this.editData.introduction)
                )
            }
            if (
                this.editData.groupInfo &&
                this.editData.groupInfo.indexOf('[') !== -1
            ) {
                this.editData.groupInfo = JSON.parse(this.editData.groupInfo)
                let arr = []
                this.editData.groupInfo.forEach((c) => {
                    arr.push(c.Id)
                })
                this.form.GroupInfo = arr
            }

            this.ProAuthList = await this.getProAuth()

            let categoryData = await this.getProductByGroupId({
                groupId: this.exhibition.groupId,
                level: 0,
                loadChild: true,
            }) // 暂时先写死了值
            if (categoryData && categoryData.length) {
                categoryData.map((c) => {
                    // c.value = c.id;
                    c.value = c.name
                    c.label = c.name
                    c.children = JSON.parse(JSON.stringify(c.list))
                    c.children.map((v) => {
                        // v.value = v.id;
                        v.value = v.name
                        v.label = v.name
                        v.children = JSON.parse(JSON.stringify(v.list))
                        v.children.map((z) => {
                            z.value = z.id
                            z.value = z.name
                            z.label = z.name
                            z.children = JSON.parse(JSON.stringify(z.list))
                        })
                    })
                })
                this.type = categoryData
            } else {
                this.type = []
            }

            // let countryList = await this.getCountryList();
            // if (countryList && countryList.length > 0) {
            //   countryList.map(c => {
            //     c.value = c.name;
            //     c.label = c.name;
            //     if (c.name === "中国") {
            //       c.loading = false;
            //       c.children = [];
            //     }
            //   });
            //   this.countryList = countryList;
            // }
            let regionList = await this.getRegionList()
            if (regionList && regionList.length > 0) {
                regionList.map((c) => {
                    c.value = c.name
                    c.label = c.name
                    c.children = c.list
                    if (c.children && c.children.length > 0) {
                        c.children.map((d) => {
                            d.value = d.name
                            d.label = d.name
                            d.children = d.list
                            if (d.children && d.children.length > 0)
                                [
                                    d.children.map((e) => {
                                        e.value = e.name
                                        e.label = e.name
                                    }),
                                ]
                        })
                    }
                })
                this.countryList = regionList
            }

            // this.form.zhaoShangRegion = [["中国", "北京", "北京市"]];
            let proChannels = await this.getProChannels()
            if (proChannels && proChannels.length > 0) {
                this.proChannels = proChannels
            }

            let proOffices = await this.getProOffices()
            if (proOffices && proOffices.length > 0) {
                this.proOffices = proOffices
            }

            setTimeout(() => {
                if (
                    this.editData.zhaoShangRegion &&
                    this.editData.zhaoShangRegion.indexOf('[') !== -1
                ) {
                    this.form.zhaoShangRegion = JSON.parse(this.editData.zhaoShangRegion)
                }
                if (!this.form.zhaoShangRegion) {
                    this.form.zhaoShangRegion = [[]]
                }
            }, 200)

            // 类目加载完毕，可保存
            msg()
            this.initLoading = false
        },
        bannerOK (list) {
            this.uploadBanner = list
        },
        videoOK (list) {
            this.uploadVideo = list
        },
        changeApply () {
            if (this.form.apply === false) {
                this.applyDate = []
                this.form.applyMaxCount = 0
            }
        },
        changePrice () {
            if (this.form.showPrice === false) {
                this.form.price = 0
                this.form.linePrice = 0
            }
        },
        validForm (name) {
            // 验证表单
            return new Promise((resolve, reject) => {
                this.$refs[name].validate((valid) => {
                    resolve(valid)
                })
            })
        },
        validSingle (name, field) {
            setTimeout(() => {
                this.$refs[name].validateField(field, (err) => {
                    console.log(err)
                })
            }, 400)
        },
        async handleSubmit (name, e) {
            let txt = ''
            this.arr = []
            this.TagData = Array.from(new Set(this.changeTag(this.form.Protag)))

            let xinStatus = 4
            let zhenStatus = 4
            let filterStatus = 4
            let arrNew = []
            this.statusPar.map(l => {
                if (l.tagId == 'fcb459d0-9565-413b-832d-f25bba4c3567') {
                    if (l.auditStatus == 'wait') {
                        xinStatus = 0
                    }
                    if (l.auditStatus == 'pass') {
                        xinStatus = 1
                    }
                    if (l.auditStatus == 'notpass') {
                        xinStatus = 2
                    }
                }
                if (l.tagId == '45866a37-7712-4177-8f77-0183d1357578') {
                    if (l.auditStatus == 'wait') {
                        zhenStatus = 0
                    }

                    if (l.auditStatus == 'pass') {
                        zhenStatus = 1
                    }
                    if (l.auditStatus == 'notpass') {
                        zhenStatus = 2
                    }

                }
                if (l.tagId == 'e2f055e2-4cec-4875-84c2-2624526391ae') {
                    if (l.auditStatus == 'wait') {
                        filterStatus = 0
                    }

                    if (l.auditStatus == 'pass') {
                        filterStatus = 1
                    }
                    if (l.auditStatus == 'notpass') {
                        filterStatus = 2
                    }

                }
            })
            console.log(this.statusPar, 'statusPar')
            console.log(xinStatus);
            console.log(zhenStatus);

            let msg=''
            this.TagData.map((h, iH) => {
                if (h.Id == 'fcb459d0-9565-413b-832d-f25bba4c3567') {
                    if (this.inDate < '2021')  {
                        msg= h.Value + '产品必须为2021年之后的产品'
                    }

                    if (xinStatus == 0) {
                        msg= h.Value + '产品标签正在审核中，请勿重新提交'

                    }
                    if (xinStatus == 1) {
                        // this.TagData.splice(iH, 1);
                    }
                    if (xinStatus == 2) {
                        arrNew.push(h)
                        this.TagData.splice(iH, 1);
                    }
                    if (zhenStatus == 4) {
                        this.TagData.splice(iH, 1);
                        arrNew.push(h)
                    }
                }
              
            })
            this.TagData.map((h, iH) => {
                if (h.Id == '45866a37-7712-4177-8f77-0183d1357578') {
                    if (zhenStatus == 0) {
                        msg= h.Value + '产品标签正在审核中，请勿重新提交'

                    }
                    if (zhenStatus == 1) {
                        // this.TagData.splice(iH, 1);
                    }
                    if (zhenStatus == 2) {
                        arrNew.push(h)
                        this.TagData.splice(iH, 1);
                    }
                    if (zhenStatus == 4) {
                        this.TagData.splice(iH, 1);
                        arrNew.push(h)
                    }
                }
              
            })
            this.TagData.map((h, iH) => {
                if (h.Id == 'e2f055e2-4cec-4875-84c2-2624526391ae') {
                    if (filterStatus == 0) {
                        msg= h.Value + '产品标签正在审核中，请勿重新提交'

                    }
                    if (filterStatus == 1) {
                        // this.TagData.splice(iH, 1);
                    }
                    if (filterStatus == 2) {
                        arrNew.push(h)
                        this.TagData.splice(iH, 1);
                    }
                    if (filterStatus == 4) {
                        this.TagData.splice(iH, 1);
                        arrNew.push(h)
                    }
                }
              
            })
            console.log(arrNew,'arrNew');
            if(msg){
                this.$Message.warning(msg)
                return
            }

            this.CategoryData = this.changeCategory()
            this.validOpen = true
            let valid = await this.validForm(name)
            this.$refs[name].fields.forEach((c) => {
                if (txt) return
                if (c.validateState === 'error') {
                    txt = c.validateMessage
                }
            })
            if (!valid && txt) {
                this.$Message.warning(txt)
            }
            if (!valid) return
            if (this.authSelectValid) {
                this.$Message.warning(this.authSelectValid)
                return
            }
            let authData = this.changeAuth()
            let qualitiesData = this.changeQualties()
            // 主图视频
            let video = {
                cover: 0,
                Time: 200,
                Img: '',
                Link: '',
            }
            if (this.uploadVideo.length > 0) {
                video.Link = this.uploadVideo[0].url
                video.Img = this.uploadVideo[0].src
            }
            // 体验报名时间、人数
            let ApplyStart = ''
            let ApplyEnd = ''
            let ApplyMaxCount = 0
            if (this.form.apply && this.applyDate.length > 0) {
                ApplyStart = this.applyDate[0]
                ApplyEnd = this.applyDate[1]
                ApplyMaxCount = this.form.applyMaxCount
            } else {
                this.form.apply = false
            }
            let canApply = ''
            if (new Date(this.applyDate[1]).getTime() > new Date().getTime()) {
                canApply = 1
            } else {
                canApply = 0
            }
            // 是否显示价格
            // if (
            //   this.form.showPrice === true &&
            //   this.form.price === 0 &&
            //   this.form.linePrice === 0
            // ) {
            //   this.$Message.error("请输入价格和划线价格");
            //   return;
            // }

            // 产品详情
            let Introduction = await this.transformReqCustomData(this.Introduction)
            if (!Introduction || Introduction === '[]') {
                this.$Message.error('请完善详情信息')
                return
            }
            let GroupInfo = []
            if (this.form.GroupInfo.length) {
                this.list.items.forEach((c) => {
                    if (this.form.GroupInfo.indexOf(c.id) !== -1) {
                        GroupInfo.push({ Id: c.id, Name: c.name })
                    }
                })
            }
           


            // let TagDataNew=[]
            // if(this.TagData.length>0){
            //     this.TagData.map((itemFormTag,indexFormTag)=>{
            //         if(itemFormTag.Id!="fcb459d0-9565-413b-832d-f25bba4c3567" || itemFormTag.Id!="45866a37-7712-4177-8f77-0183d1357578"){
            //             TagDataNew.push(itemFormTag)
            //         }
            //     })
            // }

              const stringArray = ['45866a37-7712-4177-8f77-0183d1357578', 'fcb459d0-9565-413b-832d-f25bba4c3567','e2f055e2-4cec-4875-84c2-2624526391ae'];
            // 创建一个新的对象数组，其中删除了与字符串数组中相同ID的对象
        let TagDataNew = this.TagData.filter(obj => !stringArray.includes(obj.Id));

            console.log(TagDataNew);
                        console.log(this.TagData);

            let form = {
                Id: this.editData.id,
                SetValues: {
                    Name: this.form.name,
                    NameEn: this.form.NameEn,
                    Banner: this.uploadBanner,
                    CompId: this.company.id,
                    AgentId: this.company.agentId,
                    IsApply: this.form.apply,
                    CanApply: canApply, // 控制小程序是否显示体验报名时间
                    ApplyMaxCount: ApplyMaxCount,
                    ApplyStart: ApplyStart,
                    ApplyEnd: ApplyEnd,
                    // Price: this.form.price,
                    // LinePrice: this.form.linePrice,
                    IsShow: this.form.isShow,
                    ShowIndex: this.form.showIndex,
                    Video: video,
                    GroupInfo: GroupInfo,
                    Introduction: Introduction,
                    Authentication: authData,
                    // Tag: this.TagData,
                    Tag: TagDataNew,
                    ZhaoShangRegion: this.form.zhaoShangRegion,
                    Category: this.CategoryData,
                    ApplicableChannels: this.form.proChannel,
                    AppliedSectionOffices: this.form.proOffice,
                    CertificateQualities: qualitiesData,
                    Intro: this.form.intro,
                    IntroductionEn: this.form.IntroductionEn,
                    CategoryName: this.CategoryName,
                    ProductFeature: this.form.productFeature,
                    ExArea: this.form.exArea,
                },
            }

            console.log(arrNew);
            // return
            
            
            // this.statusPar 
            console.log(this.statusPar);
            console.log(this.TagData);

            let listPass = []
            let listRemov = []

            // 先获取到通过的pass
            this.statusPar.map((itemTitle)=>{
                    if(itemTitle.auditStatus == 'pass' ){
                        listPass.push(itemTitle)
                    }
            })

            let bool = await this.editProduct(form)

            if (bool.successed) {
                this.$Message.success('保存成功')
                if (arrNew.length) {
                    let optLog = {}
                    let optList = []
                    arrNew.map(hh => {
                        optLog = {}
                        optLog.compId = this.company.id
                        optLog.productId = this.$route.query.id
                        optLog.tagId = hh.Id
                        optLog.auditStatus = 'wait'
                        optLog.exhibitionId = this.exhibition.id

                        optList.push(optLog)
                    })
                    console.log(optList);
                    let dataData = { entities: optList }
                    let log = await this.postProductTagAuditLog(dataData)
                }
                // 通过产品删除所有审核通过记录
                if(listPass.length){
                    // 再拿到新品 臻品 删除的数据
                    let differentIds = this.compareIds(listPass, this.TagData);
                    console.log(differentIds);

                    differentIds.map((itemDifferentIds)=>{
                            if(itemDifferentIds.tagId == "fcb459d0-9565-413b-832d-f25bba4c3567" || itemDifferentIds.tagId == "45866a37-7712-4177-8f77-0183d1357578" || itemDifferentIds.tagId == "e2f055e2-4cec-4875-84c2-2624526391ae" ){
                                listRemov.push(itemDifferentIds)
                            }
                    })

                    console.log(listRemov,'listRemov');
                    // 组合成后端要的数据格式
                 let  idList = listRemov.map(item => item.tagId);

                    if(differentIds.length){
                        let removOpt={
                            productId:this.$route.query.id,
                            tagId:idList,
                            exhibitionId:this.exhibition.id
        
                        }
                        console.log(removOpt);

                        let resRemov = await this.getByRemoveAuditByExId(removOpt)
                    }
                }



                // let listTagXZ = []  //选择两个活动品的数组
                // this.form.Protag.map(e => {
                //     if (e == 'fcb459d0-9565-413b-832d-f25bba4c3567' || e == '45866a37-7712-4177-8f77-0183d1357578') {
                //         listTagXZ.push(e[0])
                //     }
                // })
                // let optLog = {}
                // let optList = []
                // listTagXZ.map(e => {
                //     optLog = {}
                //     optLog.compId = this.company.id
                //     optLog.productId = bool.info
                //     optLog.tagId = e
                //     optLog.auditStatus = 'wait'
                //     optList.push(optLog)
                // })
                // let dataData = { entities: optList }
                // let log = await this.postProductTagAuditLog(dataData)






                if (e === 0) {
                    this.$router.push('/exhibition/index/product/allpro')
                }
                if (e === 1) {
                    this.$router.push('/exhibition/index/template')
                }
            } else {
                this.$Message.error('保存失败，请重新尝试')
            }
        },

        compareIds(arr1, arr2) {
  const differentIds = [];

  // 遍历第一个数组中的每个对象
  arr1.forEach(obj1 => {
    // 在第二个数组中查找具有相同id的对象
    const obj2 = arr2.find(obj2 => obj2.Id === obj1.tagId);

    // 如果找不到具有相同id的对象，则将该对象添加到differentIds数组中
    if (!obj2) {
      differentIds.push(obj1);
    }
  });

  // 遍历第二个数组中的每个对象
  arr2.forEach(obj2 => {
    // 在第一个数组中查找具有相同id的对象
    const obj1 = arr1.find(obj1 => obj1.tagId === obj2.Id);

    // 如果找不到具有相同id的对象，则将该对象添加到differentIds数组中
    if (!obj1) {
      differentIds.push(obj2);
    }
  });

  return differentIds;
},

        changModal ($event) {
            this.Introduction = $event
        },
        changeCategory (val) {
            let category = this.form.category
            if (val) {
                category = this.form.category = val
            }
              //   allProTypeList
              this.allProTypeList.map(a=>{
        a.list.map(b=>{
            if(b.name==category[0]){
                this.CategoryName = a.name
            }

        })
    })


            let data = null
            this.type.forEach((c) => {
                if (category[0] && c.name === category[0]) {
                    data = {
                        Id: c.id,
                        Value: c.name,
                        List: [],
                    }
                    if (c.list && c.list.length && category[1]) {
                        c.list.forEach((v) => {
                            if (v.name === category[1]) {
                                data.List[0] = {
                                    Id: v.id,
                                    Value: v.name,
                                }
                                if (v.list && v.list.length && category[2]) {
                                    v.list.forEach((j) => {
                                        if (j.name === category[2]) {
                                            data.List[0].list = [
                                                {
                                                    Id: j.id,
                                                    Value: j.name,
                                                    Remark: j.tag,
                                                },
                                            ]
                                        }
                                    })
                                }
                            }
                        })
                    }
                }
            })
            return data
        },
        changeTag (Protag) {
            let tag = Protag
            if (Protag[0] && Protag[0].length == 0) {
                return
            }
            let data = null
            tag.forEach((e) => {
                this.ProTagList.forEach((c) => {
                    if (e[0] && c.id === e[0]) {
                        data = {
                            Id: c.id,
                            Value: c.name,
                            List: [],
                        }
                        if (c.list && c.list.length && e[1]) {
                            c.list.forEach((v) => {
                                if (v.id === e[1]) {
                                    data.List = [
                                        {
                                            Id: v.id,
                                            Value: v.name,
                                        },
                                    ]
                                    if (v.list && v.list.length && e[2]) {
                                        v.list.forEach((j) => {
                                            if (j.id === e[2]) {
                                                data.List[0].list = [
                                                    {
                                                        Id: j.id,
                                                        Value: j.name,
                                                    },
                                                ]
                                            }
                                        })
                                    }
                                }
                            })
                        }
                    }
                })

                this.arr.push(data)
            })

            return this.arr
        },
        changeAuth () {
            let auth = this.form.Authentication
            let arr = []
            auth.forEach((c) => {
                if (c.FilePath || (c.list && c.list.length)) {
                    arr.push(c)
                }
            })
            return arr
        },
        changeQualties () {
            let auth = this.form.CertificateQualities
            let arr = []
            auth.forEach((c) => {
                if (c.FilePath) {
                    arr.push(c)
                }
            })
            return arr
        },
        async changeZhaoShangRegion (item, callback) {
            let data = await this.getCityByParentId(item.id)
            item.loading = true
            if (data && data.length > 0) {
                data.map((c) => {
                    if (c.leveltype !== 2) {
                        c.loading = false
                        c.children = []
                    }
                    c.value = c.name
                    c.label = c.name
                    c.type = item.type + 1
                })
                item.children = data
            } else {
                item.children = null
            }
            item.loading = false
            callback()
        },
        addCityArr () {
            this.form.zhaoShangRegion.push([])
        },
        delCityArr (i) {
            this.form.zhaoShangRegion.splice(i, 1)
        },
        addProductTag () {
            this.form.Protag.push([])
        },
        delProductTag (i) {
            this.form.Protag.splice(i, 1)
        },
        changeProtag (value) {
            // this.form.Protag.map(e => {
                if (value[0] == 'fcb459d0-9565-413b-832d-f25bba4c3567') {
                    this.showTextXZ = true
                } 
            // })
            // console.log(this.form.Protag);
        },
    },
    components: {
        Contact,
        upload,
        customComponentCommon,
        authSelect,
    },
    // mounted() {
    //   this.init();
    // }
}
</script>

<style lang="scss">
.editpro {
    .ivu-modal-header {
        border-bottom: none;
        padding: 14px 0;
    }
}
</style>
<style scoped lang="scss">
.ecb {
    .editpro {
        background-color: #fff;
        margin: 30px;
        min-width: 800px;

        &-box {
            padding: 20px 85px 40px 50px;
        }
    }

    .text-box {
        width: 375px;
        height: 60px;
        line-height: 60px;
        text-align: center;
        border: dashed 1px rgba(191, 191, 191, 0.5);
        border-radius: 5px;
        cursor: pointer;

        &:hover {
            border: dashed 1px rgba(23, 143, 255, 1);
        }
    }

    .c-1 {
        &:hover {
            background-color: #f2f2f2;
        }
    }

    .c-2 {
        &:hover {
            background-color: #f2f2f2;
        }
    }

    .c-3 {
        &:hover {
            background-color: #f2f2f2;
        }
    }
}

.v-center {
    display: flex;
    align-items: center;
    justify-content: center;

    .ivu-modal {
        top: 500;
    }
}

.pro-tip {
    line-height: 1;
    color: #333;
    padding-top: 6px;
}

.tipText {
    left: 430px;
    position: relative;
    top: -55px;
}
</style>
